module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Moon-44425fef47ff6bbae2cbb5aaf729fb51.svg";